import { gql } from '@apollo/client';

export default gql`
  query inspectionSubjects(
    $placeId: ID!
    $page: Int
    $name: String
    $brand: String
    $model: String
    $serialNumber: String
    $inspectionSubjectId: ID!
  ) {
    space {
      overInspectionsLimit
      adminRole
    }
    inspectionSubjects(
      placeId: $placeId
      page: $page
      name: $name
      brand: $brand
      model: $model
      serialNumber: $serialNumber
    ) {
      perPage
      hasNextPage
      inspectionSubjectsTotalPages
      inspectionSubjectsTotal
      inspectionSubjects {
        id
        name
        brand
        model
        serialNumber
        incomingInspectionsTotal
        overdueInspectionsTotal
        place {
          id
          name
        }
      }
    }
    inspectionSubject(id: $inspectionSubjectId) {
      id
      name
      brand
      model
      serialNumber
    }
  }
`;
